/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesSv = {
  privacy: {
    pageTitle: "Integritetspolicy",
    lastUpdated: "Senast uppdaterad: 1 juni 2026",
    introduction: {
      title: "Introduktion",
      body: "WasOK är en lokal shoppinghjälp-app som är utformad för att hjälpa användare att komma ihåg produkter de tidigare har köpt, betygsatt eller recenserat.\n\nDenna integritetspolicy förklarar vilken information som behandlas när du använder appen, hur data lagras och hur vissa tredjepartstjänster kan fungera.",
    },
    dataStored: {
      title: "Data som lagras av appen",
      body: "WasOK lagrar följande information lokalt på din enhet:\n\n• skannade produktstreckkoder\n• produktnamn och detaljer som anges av användaren\n• betyg och kommentarer\n• inköpslistor\n• produktkategorier\n• priser och butiksinformation\n• produkt- och butiksfoton\n\nDina produktdata och foton laddas inte upp till WasOK:s servrar.",
    },
    permissions: {
      title: "Behörigheter som används",
      camera: {
        title: "Kamera",
        body: "Kameraåtkomst används för:\n\n• streckkodsskanning\n• att ta produktfoton",
      },
      photos: {
        title: "Foton och media",
        body: "Foto- eller galleriåtkomst används endast när:\n\n• bilder bifogas till produkter\n• säkerhetskopior som innehåller foton återställs",
      },
      files: {
        title: "Fil- och lagringsåtkomst",
        body: "Filåtkomst kan användas för:\n\n• export av säkerhetskopior\n• import av säkerhetskopior som valts av användaren\n• delning av inköpslistor eller säkerhetskopior",
      },
    },
    backup: {
      title: "Säkerhetskopiering och export",
      body: "WasOK låter användare skapa säkerhetskopior som innehåller appdata och valfria foton.\n\nSäkerhetskopior skapas lokalt på din enhet och kan lagras eller delas via tjänster som du väljer, till exempel:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokal enhetslagring\n\nWasOK laddar inte upp säkerhetskopior till sina egna servrar.",
      onlineProductLookup: {
        title: "Online produktsökning",
        body: "När du aktiverar online streckkodssökning i Inställningar kan WasOK skicka endast det skannade streckkodsnumret till offentliga produktdatabaser (till exempel Open Food Facts) för att föreslå produktnamn och märke. WasOK laddar inte upp dina betyg, kommentarer, foton, inköpslistor, kategorier, butiksinformation eller säkerhetskopior för den här funktionen. Du kan stänga av detta när som helst i Inställningar.",
      },
    },
    advertising: {
      title: "Annonsering och tredjepartstjänster",
      intro:
        "WasOK använder utvalda tredjepartstjänster för att tillhandahålla vissa funktioner.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob används för att visa annonser i appen.\n\nGoogle och dess partner kan behandla information såsom:\n\n• annonsidentifierare\n• enhetsinformation\n• IP-adress\n• diagnostik- och användningsinformation\n\nAnvändare i vissa regioner kan bli ombedda om samtycke innan personliga annonser visas.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK använder Firebase Crashlytics för att identifiera krascher och förbättra appens stabilitet.\n\nKraschrapporter kan innehålla teknisk information såsom:\n\n• enhetsmodell\n• operativsystemversion\n• appversion\n• kraschdiagnostik\n\nKraschrapporter innehåller avsiktligen inte dina produktbetyg, anteckningar, inköpslistor eller foton.",
      },
      externalProductDatabases: {
        title: "Externa produktdatabaser",
        body: "Streckkodssökning kan använda externa produktdatabaser för att hämta produktinformation.\n\nFör mer information, granska respektive leverantörers integritetspolicyer.",
      },
    },
    dataSecurity: {
      title: "Datasäkerhet",
      body: "WasOK lagrar appdata lokalt på din enhet med hjälp av lagringsmekanismer som tillhandahålls av operativsystemet.\n\nÄven om rimliga åtgärder vidtas för att skydda lokal appdata är ingen metod för elektronisk lagring helt säker.\n\nAnvändare ansvarar själva för att underhålla säkerhetskopior av viktig data om så önskas.",
    },
    children: {
      title: "Barns integritet",
      body: "WasOK riktar sig inte till barn under 13 år.",
    },
    notifications: {
      title: "Aviseringar",
      body: "WasOK kan valfritt skapa lokala aviseringar på din enhet för att påminna dig om att betygsätta produkter efter köp.\n\nDessa aviseringar skapas och schemaläggs lokalt på din enhet och kräver inget konto eller fjärrserver.\n\nDu kan inaktivera aviseringar när som helst via enhetsinställningarna eller i appen, om det stöds.",
    },
    yourControl: {
      title: "Din kontroll över data",
      body: "Du kan:\n\n• redigera eller ta bort lagrade produkter när som helst\n• rensa appdata från din enhet\n• avinstallera appen\n• exportera säkerhetskopior av dina data",
    },
    changes: {
      title: "Ändringar av denna policy",
      body: "Denna integritetspolicy kan uppdateras från tid till annan.\n\nÄndringar träder i kraft när den uppdaterade versionen publiceras.",
    },
    contact: {
      title: "Kontakt",
      body: "Om du har frågor om denna integritetspolicy, kontakta:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Användarvillkor",
    lastUpdated: "Senast uppdaterad: 1 juni 2026",
    acceptance: {
      title: "Godkännande av villkor",
      body: "Genom att ladda ner, installera eller använda WasOK godkänner du dessa användarvillkor.\n\nOm du inte godkänner dessa villkor ska du inte använda appen.",
    },
    license: {
      title: "Licens",
      body: "WasOK ger dig en begränsad, icke-exklusiv, icke-överlåtbar, återkallelig licens att använda appen i enlighet med dessa villkor.",
    },
    acceptableUse: {
      title: "Acceptabel användning",
      body: "Du åtar dig att inte:\n\n• missbruka appen\n• störa appens drift\n• försöka reverse-engineera eller modifiera appen\n• använda appen i strid med tillämpliga lagar eller regler",
    },
    localData: {
      title: "Lokal data och säkerhetskopior",
      body: "WasOK lagrar användardata lokalt på enheten.\n\nAnvändare ansvarar själva för att underhålla säkerhetskopior av viktig data om så önskas.\n\nÄven om säkerhetskopiering och återställning kan tillhandahållas garanterar WasOK inte mot förlust, korruption eller fel på lagrad data.",
    },
    advertisements: {
      title: "Annonser",
      body: "Appen kan visa annonser som tillhandahålls av tredjepartsannonsörer, inklusive Google AdMob.",
    },
    noWarranty: {
      title: "Ingen garanti",
      body: "WasOK tillhandahålls \"i befintligt skick\" och \"som tillgänglig\" utan garantier av något slag, uttryckliga eller underförstådda.\n\nVi garanterar inte att:\n\n• appen alltid är tillgänglig\n• appen är felfri\n• dataförlust aldrig sker\n• alla funktioner fungerar oavbrutet på alla enheter",
    },
    limitationLiability: {
      title: "Ansvarsbegränsning",
      body: "I den utsträckning som lagen tillåter ska WasOK och dess utvecklare inte hållas ansvariga för:\n\n• dataförlust\n• vinstförlust\n• enhetsproblem\n• indirekta eller följdskador\n• avbrott till följd av användning eller oförmåga att använda appen",
    },
    thirdParty: {
      title: "Tredjepartstjänster",
      body: "Vissa funktioner eller innehåll kan förlita sig på tredjepartstjänster, inklusive annonsleverantörer och externa lagrings-/delningstjänster som valts av användaren.\n\nWasOK ansvarar inte för tredjepartstjänster eller deras policyer.",
    },
    productInformation: {
      title: "Produktinformation",
      body: "Vissa produktdetaljer kan hämtas från tredjeparts streckkodssökningstjänster.\n\nWasOK garanterar inte riktigheten, fullständigheten, tillgängligheten eller lämpligheten av information från externa datakällor.\n\nAnvändare bör självständigt verifiera produktinformation när det behövs.",
    },
    changesApp: {
      title: "Ändringar av appen",
      body: "WasOK kan modifieras, uppdateras, pausas eller läggas ner när som helst utan föregående meddelande.",
    },
    changesTerms: {
      title: "Ändringar av dessa villkor",
      body: "Dessa villkor kan uppdateras periodiskt.\n\nFortsatt användning av appen efter att uppdateringar trätt i kraft utgör godkännande av de reviderade villkoren.",
    },
    contact: {
      title: "Kontakt",
      body: "För frågor om dessa villkor, kontakta:\n\nsupport@wasok.app",
    },
  },
};
